<template>
	<div>
		<div class="header-container" :class="showHeader ? '' : 'hide-header'">
			<div class="header-inner" :class="headerMini ? 'show-mini-nav' : ''">
				<div class="logo-block">
					<img src="../assets/test/logo.svg" class="logo-img" v-if="showHeader" />
					<img src="../assets/test/2logo.svg" class="logo-img" v-else />
				</div>
				<div class="header-menu-container">
					<div class="f-menu-box">
						<div class="f-menu-block" @click="toPage('/locations')">
							<span class="f-menu-txt">Locations</span>
							<!-- <span class="iconfont icon-xiangxia"></span> -->
						</div>
						<div class="f-menu-block" @click="toPage('/careers')">
							<span class="f-menu-txt">Careers</span>
						</div>
						<div class="f-menu-block" @click="toPage('/aboutus')">
							<span class="f-menu-txt">About</span>
						</div>
					</div>
					<div class="s-menu-box">
						<div class="s-menu-block" :class="menuName == 'search' ? 's-menu-select' : ''"
							@click="openSearch">
							<span class="iconfont icon-sousuo"></span>
						</div>
						<div class="s-menu-block" @click="toPage('/people')">
							<span class="s-menu-txt">People</span>
						</div>
						<div class="s-menu-block" :class="menuName == 'Experience' ? 's-menu-select' : ''"
							@click="openExperience">
							<span class="s-menu-txt">Expertise</span>
							<span class="iconfont icon-xiangxia"></span>
						</div>
						<div class="s-menu-block" @click="toPage('/newsroom')">
							<span class="s-menu-txt">News</span>
						</div>
						<div class="s-menu-block" :class="menuName == 'Insights' ? 's-menu-select' : ''"
							@click="openLights">
							<span class="s-menu-txt">Insight</span>
							<span class="iconfont icon-xiangxia"></span>
						</div>
					</div>
				</div>
			</div>
			<div :class="showInsights ? 'show-insights' : ''">
				<div class="insight-nav" v-if="showInsights">
					<div class="insight-nav__column">
						<div class="subcategory-label">Latest Thinking
							<a class="subcategory-label__link link--bold" style="cursor: pointer;"
								@click="toPage('/insight')" tabindex="0">View All </a>
						</div>
						<div class="insight-nav__description">
							<p>Explore our insight by industries, practices and locations</p>
							<p><a @click="toPage('/insight/podcasts')" tabindex="0" style="cursor: pointer;"><span
										class="link--bold">Podcasts <span
											class="iconfont icon-xiangyou1"></span></span></a></p>
							<p><a @click="toPage('/insight/blogs')" tabindex="0" style="cursor: pointer;"><span
										class="link--bold">Blogs <span
											class="iconfont icon-xiangyou1"></span></span></a></p>
						</div>

						<div class="subcategory-label current-awareness-label">InsightPlus <a
								class="subcategory-label__link link--bold" style="cursor: pointer;" @click="toPage('/')"
								tabindex="0" target="_blank">Visit
								Site <span class="iconfont icon-xiangyou1"></span></a></div>
						<div class="insight-nav__description">Access our full range of legal alerts and newsletters
						</div>
					</div>
					<div class="insight-nav__column">
						<div class="subcategory-label">Trending Content</div>
						<ul class="insight-nav__topic-tags">
							<li class="insight-nav__topic-tag"><a class="insight-nav__topic-tag-label"
									tabindex="0">Workforce Redesign: Outlooks
									for
									Business Leaders</a></li>
							<li class="insight-nav__topic-tag"><a class="insight-nav__topic-tag-label"
									tabindex="0">COP28 Hub: STEPS to Net Zero</a></li>
							<li class="insight-nav__topic-tag"><a class="insight-nav__topic-tag-label"
									tabindex="0">Connected Compliance</a>
							</li>
							<li class="insight-nav__topic-tag"><a class="insight-nav__topic-tag-label"
									tabindex="0">Healthcare &amp; Life
									Sciences Hub </a></li>
							<li class="insight-nav__topic-tag"><a class="insight-nav__topic-tag-label"
									tabindex="0">Cross-Border M&amp;A
									Resource Center</a></li>
							<li class="insight-nav__topic-tag"><a class="insight-nav__topic-tag-label"
									tabindex="0">Hydrogen Hub</a></li>
						</ul>
					</div>
					<div class="insight-nav__column">
						<div class="insight-nav__feature">
							<div class="insight-nav__feature-type"> </div>
							<div class="insight-nav__feature-title">The Year Ahead Global Disputes Forecast 2024</div>
							<div class="insight-nav__feature-copy">Our seventh annual report provides detailed analysis
								of
								disputes trends, as well as sectoral and region-specific developments, to prepare your
								organization for The Year Ahead.</div>
							<a class="insight-nav__feature-link link--bold">Learn More <span
									class="iconfont icon-xiangyou1"></span></a>
						</div>
					</div>
				</div>
			</div>
			<div class="show-expertise" v-if="showExperience">
				<ul id="experience-list" class="subcategories hide-experience-editor menu-scroll-area"
					aria-hidden="false" aria-live="polite">
					<li class="subcategory">
						<div class="subcategory-label">Industries</div>
						<ul class="secondary-links">
							<li class="column column-full">
								<ul>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Consumer Goods &amp;
											Retail</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Energy, Mining
											&amp; Infrastructure</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Financial
											Institutions</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Healthcare &amp; Life Sciences</a>
									</li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Hotels, Resorts &amp;
											Tourism</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')">
											Industrials, Manufacturing &amp; Transportation</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Private Equity</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Technology,
											Media &amp; Telecommunications </a> </li>
								</ul>
							</li>
						</ul>
					</li>
					<li class="subcategory">
						<div class="subcategory-label">Solutions</div>
						<ul class="secondary-links">
							<li class="column column-full">
								<ul>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Digital
											Transformation</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Energy Transition</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Reinvent</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Supply Chains</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Sustainability and
											ESG</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Transactions</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Workforce Redesign</a> </li>
								</ul>
							</li>
						</ul>
					</li>
					<li class="subcategory">
						<div class="subcategory-label">Practices</div>
						<ul class="secondary-links">
							<li class="column">
								<ul>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Antitrust &amp;
											Competition</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Artificial
											Intelligence</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Banking &amp; Finance</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Capital Markets</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Cybersecurity &amp;
											Data Privacy</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Data &amp; Technology</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Dispute Resolution</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Employment &amp; Compensation</a>
									</li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Environment &amp;
											Climate Change</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Intellectual Property</a>
									</li>
								</ul>
							</li>
							<li class="column">
								<ul>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> International
											Commercial &amp; Trade</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Investigations,
											Compliance &amp; Ethics</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Investment Funds</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Mergers &amp;
											Acquisitions</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Private Equity</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')">Projects</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Real Estate</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')"> Restructuring &amp;
											Insolvency</a> </li>
									<li class="secondary-link"> <a class="secondary-link-label expertise-link-item"
											@click="toPage('/expertise/articel')">
											Tax</a> </li>
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="concierge-search-container show-search" v-if="showSearch">
				<div class="concierge-search">
					<form class="search-input" action="#" method="get">
						<div class="button-submit"><span class="iconfont icon-sousuo" style="font-size: 30px;"></span>
						</div>
						<div role="button" class="bm bm-close mobile-close"></div>
						<div class="input-container">
							<label id="sitesearchlabel" class="accessible-label" for="sitesearch">How Can We
								Help?</label>
							<input id="sitesearch" class="input" type="text" name="sitesearch" tabindex="0"
								aria-labelledby="sitesearchlabel" autocomplete="off">
							<span class="sitesearch__placeholder">How Can We Help?</span>
						</div>
					</form>
					<div class="search-results-dropdown concierge-search-results-container autocomplete-suggestions-wrapper"
						data-suggestedlabel="Suggested Results">
						<div class="autocomplete-suggestions" style="position: absolute; display: none; z-index: 9999;">
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--mobile-->
		<div class="mobile-header-container global-header global-header--dark global-header--home hide-print headroom at-top-of-page " :class="mobileShowinsight ? 'show-mobile-nav show-insights' : (mobileShowExpertise ? 'show-mobile-nav show-expertise' : (showMobileNav ? 'show-mobile-nav' : ''))">
			<div class="mobile-nav-header">
				<button class="primary-nav-trigger bm bm-mobile-menu" aria-label="Menu" @click="openMobileNav"></button>
				<a class="mobile-logo-a"><img @click="toPage('/')" class="logo mobile-logo" alt="Baker McKenzie"
						src="../assets/test/75logo.svg" tabindex="-1"> </a>
				<button class="mobile-nav-locations-trigger bm bm-map-marker" aria-label="Locations" @click="toPage('/locations')"></button>
			</div>
			<div class="primary">
				<div class="concierge-search-container">
					<div class="concierge-search">
						<div class="search-input">
							<button class="button-submit" aria-label="Submit Search" type="submit">
								<div class="bm bm-search"></div>
							</button>
							<div role="button" class="bm bm-close mobile-close"></div>
							<div class="input-container">
								<label id="sitesearchlabel" class="accessible-label" for="sitesearch">How Can We
									Help?</label>
								<input id="sitesearch" class="input" type="text" name="sitesearch" tabindex="0"
									aria-labelledby="sitesearchlabel" autocomplete="off">
								<span class="sitesearch__placeholder">How Can We Help?</span>
							</div>
						</div>
						<div class="search-results-dropdown concierge-search-results-container autocomplete-suggestions-wrapper"
							data-suggestedlabel="Suggested Results">
							<div class="autocomplete-suggestions"
								style="position: absolute; display: none; z-index: 9999;"></div>
						</div>
					</div>
				</div>
				<nav class="primary-nav">
					<ul class="upper-links">
						<li class="upper-link">
							<a class="upper-link-label" tabindex="0" @click="toPage('/aboutus')">About</a>
						</li>
						<li class="upper-link">
							<a class="upper-link-label" tabindex="0" @click="toPage('/careers')">Careers</a>
						</li>
					</ul>
					<ul class="primary-links">
						<li class="primary-link insight-links">
							<button class="primary-link-label insights-link-label mobile-menu-label" aria-controls="experience-list" aria-expanded="false" aria-haspopup="true" @click="openMobileInsight">Insight</button>
							<div class="insight-nav">
								<div class="insight-nav__column">
									<div class="subcategory-label">Latest Thinking 
									<a class="subcategory-label__link link--bold" @click="toPage('/insight')" tabindex="-1">View All</a></div>
									<div class="insight-nav__description">
										<p>Explore our insight by industries, practices and locations</p>
										<p><a @click="toPage('/insight/podcasts')" tabindex="-1"><span class="link--bold">Podcasts</span></a></p>
										<p><a @click="toPage('/insight/blogs')" tabindex="-1"><span class="link--bold">Blogs</span></a></p>
									</div>
									<div class="subcategory-label current-awareness-label">InsightPlus 
									<a class="subcategory-label__link link--bold" @click="toPage('/')" tabindex="-1" target="_blank">Visit Site</a></div>
									<div class="insight-nav__description">Access our full range of legal alerts and newsletters</div>
								</div>
								<div class="insight-nav__column">
									<div class="subcategory-label">Trending Content</div>
									<ul class="insight-nav__topic-tags">
										<li class="insight-nav__topic-tag">
											<a class="insight-nav__topic-tag-label" @click="toPage('/insight')" tabindex="-1">Workforce Redesign: Outlooks for Business Leaders</a>
										</li>
										<li class="insight-nav__topic-tag">
											<a class="insight-nav__topic-tag-label" @click="toPage('/insight')" tabindex="-1">COP28 Hub: STEPS to Net Zero</a>
										</li>
										<li class="insight-nav__topic-tag">
											<a class="insight-nav__topic-tag-label" @click="toPage('/insight')" tabindex="-1">Connected Compliance</a>
										</li>
										<li class="insight-nav__topic-tag">
											<a class="insight-nav__topic-tag-label" @click="toPage('/insight')" tabindex="-1">Hydrogen Hub</a>
										</li>
									</ul>
								</div>
							</div>
						</li>
						<li class="primary-link">
							<a class="primary-link-label insights-link-label" @click="toPage('/newsroom')">News</a>
						</li>
						<li class="primary-link expertise-links">
							<button class="primary-link-label mobile-menu-label" tabindex="0" aria-controls="experience-list" aria-expanded="false" aria-haspopup="true" @click="openMobileExpertise">Expertise</button>
							<ul id="experience-list" class="subcategories hide-experience-editor menu-scroll-area" aria-hidden="true" aria-live="polite">
								<li class="subcategory show-subcategor" >
									<div class="subcategory-label">Industries</div>
									<ul class="secondary-links" style="display: block;">
										<li class="column column-full">
											<ul>
												<li class="secondary-link"> 
													<a @click="toPage('/expertise/articel')" class="secondary-link-label expertise-link-item" tabindex="-1">Consumer Goods &amp; Retail</a> 
												</li>
												<li class="secondary-link"> 
													<a @click="toPage('/expertise/articel')" class="secondary-link-label expertise-link-item" tabindex="-1">Energy, Mining &amp; Infrastructure</a>
												</li>
												<li class="secondary-link"> 
													<a @click="toPage('/expertise/articel')" class="secondary-link-label expertise-link-item" >Financial Institutions</a>
												</li>
												<li class="secondary-link"> 
													<a @click="toPage('/expertise/articel')" class="secondary-link-label expertise-link-item" >Technology, Media &amp; Telecommunications </a> 
												</li>
											</ul>
										</li>
									</ul>
								</li>
							</ul>
						</li>
						<li class="primary-link">
							<a class="primary-link-label insights-link-label" @click="toPage('/people')">People</a>
						</li>
						<li class="primary-link search-link">
							<button class="bm bm-search search-link-label" tabindex="0"
								aria-label="Toggle Global Search"></button>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'Header',
		props: {
			showHeader: {
				type: Boolean,
				default: true,
			},
			isHome: {
				type: Boolean,
				default: false,
			},
			headerMini: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				menuList: [],
				showInsights: false,
				showExperience: false,
				menuName: '',
				showSearch: false,
				mobileShowExpertise:false,
				mobileShowinsight:false,
				showMobileNav:false
			}
		},
		watch: {
			headerMini: {
				handler(newVal, oldVal) {
					this.showInsights = false
					this.showExperience = false
					this.showSearch = false
					this.menuName = ''
				},
				deep: true
			}
		},
		created() {

		},
		methods: {
			changeTab(val, index) {
				this.menuIndex = index
				this.$router.replace(val.path);
				//this.$emit('changeTab',index)
			},
			openTrialShow() {
				this.$emit('openTrialShow')
			},
			openLights() {
				this.showInsights = !this.showInsights
				this.showExperience = false
				if (this.showInsights) {
					this.menuName = 'Insights'
					this.showHeader = true
				} else {
					this.menuName = ''
					if (this.isHome) {
						this.showHeader = false
					}
				}
			},
			openExperience() {
				this.showExperience = !this.showExperience
				this.showInsights = false
				if (this.showExperience) {
					this.menuName = 'Experience'
					this.showHeader = true
				} else {
					this.menuName = ''
					if (this.isHome) {
						this.showHeader = false
					}
				}
			},
			openSearch() {
				this.showSearch = !this.showSearch
				this.showInsights = false
				this.showExperience = false
				if (this.showSearch) {
					this.menuName = 'search'
					this.showHeader = true
				} else {
					this.menuName = ''
					if (this.isHome) {
						this.showHeader = false
					}
				}
			},
			toPage(path) {
				this.$router.replace(path);
			},
			openMobileInsight(){
				this.mobileShowinsight = !this.mobileShowinsight
			},
			openMobileExpertise(){
				this.mobileShowExpertise = !this.mobileShowExpertise
			},
			openMobileNav(){
				this.showMobileNav = !this.showMobileNav
			}
		}
	}
</script>
<style src="@/assets/main.css" scoped></style>
<style lang='scss' scoped>
	

	@media (min-width: 801px) {
		.mobile-header-container {
			display: none;
		}

		.header-container {
			display: block;
		}
		
		.header-container {
			width: 100%;
			position: fixed;
			background-color: #fff;
			z-index: 99;
			transition: transform 0.8s cubic-bezier(0.86, 0, 0.07, 1);
			border-bottom: 1px solid #D2D2D2;
		
			.header-inner {
				width: 100%;
				height: 100%;
				overflow: hidden;
				position: relative;
		
				.logo-block {}
		
				.header-menu-container {
					float: right;
					width: auto;
					height: 100%;
					overflow: hidden;
					cursor: pointer;
		
					.f-menu-box {
						width: calc(100% - 30px);
						margin: 10px 15px 0;
						height: auto;
						overflow: hidden;
					}
		
					.s-menu-box {
						width: calc(100% - 30px);
						margin: 0 15px 0;
						height: auto;
						overflow: hidden;
					}
		
					.menu-inner {
						float: right;
						/* width: 87px; */
						height: 100%;
						overflow: hidden;
		
						.menu-txt {
							width: 100%;
							/* height: 21px;
							line-height: 21px;
							font-size: 15px;
							color: #333;
							text-align: center;
							margin: 26px 0 0; */
						}
		
						.menu-txt-selected {
							color: #4087FF;
						}
		
						.menu-selected {
							/* width: 37px;
							height: 3px; */
							background-color: #4087FF;
							border-radius: 4px;
							margin: 0 auto;
						}
					}
				}
			}
		}
		
		.header-container .show-mini-nav {
			transform: translateY(-100%);
		}
		
		.header-container {
			height: 82px;
			color: #323232;
		
			.header-inner {
		
				.logo-block {
					height: 65px;
					line-height: 65px;
					float: left;
					margin: 13px 0 0 40px;
		
					.logo-img {
						float: left;
						width: 142px;
						height: 65px;
						margin: 0 15px 0 0;
					}
		
					.logo-name {
						float: left;
						font-size: 23px;
						color: #fff;
					}
				}
		
				.header-menu-container {
		
					.f-menu-box {
						height: 30px;
						line-height: 30px;
		
						.f-menu-block {
							float: right;
							margin-left: 1em;
							margin-right: 1em;
							font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
							font-weight: normal;
							font-style: normal;
							text-transform: uppercase;
							transition: color 0.4s;
							font-weight: bold;
							font-size: 0.875em;
		
							.iconfont {
								font-size: 12px;
								font-weight: bold;
								margin-left: 5px;
							}
						}
					}
		
					.f-menu-block:hover {
						color: #ad122a;
					}
		
					.s-menu-box {
						height: 30px;
						line-height: 30px;
		
						.s-menu-block {
							float: right;
							margin-left: 1.5em;
							margin-right: 1.5em;
							transition: color 0.4s, background-color 0.4s;
							font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
							font-weight: normal;
							font-style: normal;
							font-weight: bold;
							font-size: 1.125em;
						}
		
						.iconfont {
							margin-left: 5px;
						}
		
						.icon-sousuo {
							font-size: 22px;
						}
		
						.s-menu-block:hover {
							color: #ad122a;
						}
		
						.s-menu-select {
							color: #ad122a;
						}
					}
				}
			}
		}
		
		.hide-header {
			background: transparent !important;
			color: #fff !important;
			border-bottom: unset !important;
		}
		
		.insight-nav {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			background-color: #FFF;
			border-bottom: 1px solid #D2D2D2;
			padding: 2.5em 6.5625em;
			transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1), opacity 0.4s cubic-bezier(0.86, 0, 0.07, 1);
			transform: translateY(-100%);
			z-index: -1;
			opacity: 0;
			max-width: 100%;
			margin-left: auto;
			margin-right: auto;
		}
		
		.show-insights .insight-nav {
			transform: translateY(0);
			opacity: 1;
		}
		
		.insight-nav__column {
			width: 26.915%;
			float: left;
			margin-right: 2.1275%;
		}
		
		.insight-nav .subcategory-label {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-weight: bold;
		}
		
		.insight-nav .subcategory-label {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-size: 1.5em;
			font-weight: bold;
			border-bottom: 1px solid #D2D2D2;
			margin-bottom: 0.5em;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-pack: justify;
			justify-content: space-between;
			white-space: normal;
		}
		
		.insight-nav .subcategory-label__link.link--bold {
			padding-left: 32px;
		}
		
		.insight-nav .subcategory-label__link .icon-xiangyou1 {
			font-size: 16px;
		}
		
		.insight-nav .subcategory-label__link {
			font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-weight: 700;
			display: -ms-flexbox;
			display: flex;
			-ms-flex: 0 0 auto;
			flex: 0 0 auto;
			-ms-flex-align: end;
			align-items: flex-end;
			padding-bottom: 10px;
		}
		
		.link--bold {
			text-transform: uppercase;
			font-weight: bold;
			font-size: 14px;
			line-height: 15px;
			padding-right: 18px;
			-ms-flex-align: center;
			align-items: center;
			position: relative;
			transition: padding 0.4s ease-in-out;
		}
		
		a {
			color: #ad122a;
			transition: color 0.4s, background-color 0.4s;
		}
		
		.insight-nav .subcategory-label__link.link--bold:before {
			bottom: 17px;
		}
		
		.link--bold:before {
			content: "";
			position: absolute;
			right: 5px;
			bottom: 8px;
			height: 2px;
			width: 0;
			background-color: #ad122a;
			transition: width 0.4s ease-in-out;
		}
		
		.insight-nav .subcategory-label__link.link--bold:after {
			bottom: 10px;
		}
		
		.link--bold:after {
			content: "";
			font-family: "bakermckenzie";
			font-size: 12px;
			font-weight: 100;
			position: absolute;
			right: 0;
			bottom: 1px;
			transition: right 0.4s ease-in-out;
		}
		
		.insight-nav .current-awareness-label {
			padding-top: 1rem;
		}
		
		.insight-nav .subcategory-label {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-weight: bold;
		}
		
		.insight-nav .subcategory-label {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-size: 1.5em;
			font-weight: bold;
			border-bottom: 1px solid #D2D2D2;
			margin-bottom: 0.5em;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-pack: justify;
			justify-content: space-between;
			white-space: normal;
		}
		
		.insight-nav ul {
			list-style-type: none;
			padding: 0;
		}
		
		.insight-nav__topic-tags {
			display: -ms-flexbox;
			display: flex;
			-ms-flex-wrap: wrap;
			flex-wrap: wrap;
		}
		
		.insight-nav__topic-tag {
			margin-right: 0.875em;
			margin-bottom: 0.875em;
		}
		
		.insight-nav__topic-tag-label {
			display: block;
			font-size: 0.875em;
			background-color: #F0F0F0;
			padding: 0.65em 1.275em;
			color: #646464;
			font-weight: 500;
			letter-spacing: 1px;
		}
		
		.insight-nav__column:last-of-type {
			/* float: right; */
			margin-right: 0;
		}
		
		.insight-nav .insight-nav:after {
			content: " ";
			display: block;
			clear: both;
		}
		
		.insight-nav__feature {
			background-color: #ad122a;
			color: #FFF;
			padding: 2.625em 2.25em;
		}
		
		.insight-nav__feature-type {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
		}
		
		.insight-nav__feature-title {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-size: 1.5em;
			line-height: 1.15;
			padding: 0.75em 0;
			font-weight: bold;
		}
		
		.insight-nav__feature-copy {
			padding-bottom: 1em;
			letter-spacing: 2px;
		}
		
		.insight-nav__feature-link {
			color: #FFF;
		}
		
		.insight-nav__description {
			letter-spacing: 2px;
		}
		
		.show-expertise .subcategories {
			transform: translateY(0);
			opacity: 1;
			margin: 0;
		}
		
		.show-expertise .menu-scroll-area {
			min-height: 20vh;
			overflow-y: auto;
		}
		
		.subcategories {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			background-color: #FFF;
			border-bottom: 1px solid #D2D2D2;
			padding: 2.5em 6.5625em;
			transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1), opacity 0.4s cubic-bezier(0.86, 0, 0.07, 1);
			transform: translateY(-100%);
			z-index: -1;
			opacity: 0;
			max-width: 100%;
			margin-left: auto;
			margin-right: auto;
		}
		
		.show-expertise ul {
			list-style-type: none;
		}
		
		.show-expertise .subcategory {
			width: 23.40438%;
			float: left;
			margin-right: 2.1275%;
		}
		
		.show-expertise .subcategory:last-of-type {
			width: 48.93625%;
			float: left;
			margin-right: 2.1275%;
			float: right;
			margin-right: 0;
		}
		
		.show-expertise .subcategory-label {
			font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-size: 1.5em;
			font-weight: bold;
			border-bottom: 1px solid #D2D2D2;
			margin-bottom: 0.5em;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-pack: justify;
			justify-content: space-between;
			white-space: normal;
		}
		
		.show-expertise .secondary-links {
			max-width: 100%;
			margin-left: auto;
			margin-right: auto;
			padding: 0;
		}
		
		.show-expertise ul {
			list-style-type: none;
		}
		
		.show-expertise .secondary-links .column:last-of-type {
			margin-right: 0;
		}
		
		.show-expertise .secondary-links .column {
			width: 46.66693%;
			float: left;
			margin-right: 6.66613%;
		}
		
		.show-expertise .secondary-links .column ul {
			padding: 0;
		}
		
		.show-expertise .secondary-links .column-full {
			width: 100%;
			float: left;
			margin-left: 0;
			margin-right: 0;
		}
		
		.show-expertise .secondary-link {
			padding: 0.5em 0;
			white-space: normal;
			font-weight: bold;
			letter-spacing: 1px;
		}
		
		.show-expertise .secondary-link-label {
			position: relative;
			display: inline-block;
			font-size: 1em;
		}
		
		input {
			border: none;
			padding: 0;
		}
		
		.expertise-link-item {
			cursor: pointer;
		}
		
		.concierge-search-container .concierge-search {
			width: 100%;
		}

		.concierge-search {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1), opacity 0.4s cubic-bezier(0.86, 0, 0.07, 1);
			transform: translateY(-100%);
			z-index: -1;
			opacity: 0;
			max-width: 100%;
			margin-left: auto;
			margin-right: auto;
		}

		.show-search .concierge-search {
			transform: translateY(0);
			opacity: 1;
		}

		.search-input {
			background-color: #F0F0F0;
			padding: 0.3125em 0.625em;
			border: 1px solid #cececd;
			color: #001A32;
			position: relative;
			border-radius: 3px;
		}

		.concierge-search-container .search-input {
			padding: 0.5em 1em;
			border: none;
			border-radius: 0;
			background-color: #F0F0F0;
			color: #646464;
			font-size: 1.375em;
		}

		.autocomplete-suggestions-wrapper {
			position: relative;
			margin-right: -2px;
			z-index: 4 !important;
		}

		.concierge-search-container .search-results-dropdown {
			border: none;
			border-top: 1px solid #D2D2D2;
			background-color: #F0F0F0;
		}

		.autocomplete-suggestions-wrapper.concierge-search-results-container {
			box-shadow: 0 3px 3px 0 rgba(95, 95, 95, 0.7);
		}

		.autocomplete-suggestions-wrapper.concierge-search-results-container .autocomplete-suggestions {
			font-size: 1em;
		}

		.autocomplete-suggestions-wrapper .autocomplete-suggestions {
			background-color: #FFF;
			padding: 0;
			display: block;
			position: absolute;
			text-rendering: optimizeLegibility;
			overflow-y: scroll;
			max-height: 75vh;
			width: 100% !important;
			font-size: .85em;
			left: -1px;
			right: 0;
			top: 0;
			border-radius: 0 0 3px 3px;
			border-left: 1px solid #cececd;
			border-right: 1px solid #cececd;
			border-bottom: 1px solid #cececd;
		}

		.concierge-search-container .search-input .button-submit {
			color: #323232;
		}

		.search-input .button-submit {
			padding: 0.7em 0.75em 0;
			color: inherit;
			height: 100%;
			position: absolute;
			top: 0;
			right: 0;
		}

		.bm,
		.promo-content-tile .content .external-link-icon:before {
			display: inline-block;
			font-family: "bakermckenzie";
			font-style: normal;
			font-weight: normal;
			font-variant: normal;
			font-size: inherit;
			speak: none;
			line-height: 1;
			text-transform: none !important;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			vertical-align: -6.14286%;
		}

		.concierge-search .mobile-close {
			display: none;
		}

		.search-input .input-container {
			background-color: inherit;
			overflow: hidden;
			width: 99%;
			padding: 0.375em;
			padding: 0.375em;
		}

		.accessible-label {
			position: absolute;
			left: -10000px;
			top: auto;
			width: 1px;
			height: 1px;
			overflow: hidden;
		}

		.search-input .input,
		.search-input input[type='text'] {
			background-color: transparent;
			width: 100%;
			color: inherit;
			font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
			font-weight: normal;
			font-style: normal;
			font-size: 1.125em;
		}

		.concierge-search-container .sitesearch__placeholder {
			position: absolute;
			left: 0;
			top: 50%;
			pointer-events: none;
			transform: translateY(-50%);
			padding-left: 1.375em;
			letter-spacing: 2px;
		}
	}

	/* mobile screen */
	@media (max-width: 800px) {
		.header-container {
			display: none;
		}

		.mobile-header-container {
			display: block;
			
			.mobile-menu-label {
				width: 91% !important;
			}
		}

		.mobile-logo-a {
			float: left;
			width: calc(100% - 36px);
			padding: .55em 0;
		}

		.bm-mobile-menu {
			float: left;
			height: 25px !important;
		}

		.mobile-nav-locations-trigger {
			float: left;
			height: 25px !important;
		}

		.mobile-logo {
			display: block;
			margin: 0 auto;
		}
		.insight-nav__column {
			width: 86% !important;
		}
	}
</style>
